// import Vue from 'vue'
// const Vue = require('vue')
import u8Container from './u8-container';
import u8IconBtn from './u8-icon-btn';
import u8InfoItem from './u8-info-item';
import u8SmsCD from './u8-sms-cd';
import u8Rank from './u8-rank';
Vue.component('u8-container', u8Container);
Vue.component('u8-icon-btn', u8IconBtn);
Vue.component('u8-info-item', u8InfoItem);
Vue.component('u8-sms-cd', u8SmsCD);
Vue.component('u8-rank', u8Rank);